import StandardRestError from './Standard'

class MembershipLimitError extends StandardRestError {
  static CODE = 'MEMBERSHIP_LIMIT_EXCEEDED'

  constructor(
    message = 'You are already a member of another account.',
    status = 429,
    body = {},
  ) {
    super(message)
    this.status = status
    this.body = body
  }
}

export default MembershipLimitError
